module.exports = __webpack_public_path__ + "img/Presentation7.83a71ab8.png";